import * as React from 'react';
import { IconActionSort16 } from '@cian/ui-kit-design-tokens/icons';
import { IBaseSelectProps } from '../../types/select';
import { SelectLabel } from '../SelectLabel';
import { PopoverDropdown } from './PopoverDropdown';
import * as styles from './styles.css';

export function PopoverSelect({ value, values, onChange }: IBaseSelectProps): React.JSX.Element {
  const [isOpened, setOpenedState] = React.useState(false);
  const currentValue = values.find(({ id }) => value === id);

  const onValueChange = React.useCallback(
    (value: number) => {
      setOpenedState(false);
      onChange(value);
    },
    [setOpenedState, onChange],
  );
  const onLabelClick = React.useCallback(() => {
    setOpenedState(true);
  }, [setOpenedState]);
  const onDropdownClose = React.useCallback(() => {
    setTimeout(() => setOpenedState(false));
  }, [setOpenedState]);

  return (
    <div className={styles['container']}>
      <SelectLabel icon={<IconActionSort16 color="icon-main-default" />} onClick={onLabelClick}>
        {currentValue?.text || 'Не выбрано'}
      </SelectLabel>
      {isOpened && (
        <PopoverDropdown value={value} values={values} onValueChange={onValueChange} onClose={onDropdownClose} />
      )}
    </div>
  );
}
